import { Component, EventEmitter, HostListener, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { NavigationService } from '../../../core/service/navigation.service';
import { SidebarItemDefinition } from '../../../common/model/sidebar-item';

export enum ViewType {
  desktop = 1,
  mobile = 2,
}

@Component({
    selector: 'app-dashboard-item',
    templateUrl: './dashboard-item.component.html',
    styleUrls: ['./dashboard-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardItemComponent implements OnInit {
  constructor(private _navigation: NavigationService) {}

  updates: number;
  @Input() definition: SidebarItemDefinition;
  @Input() viewType: ViewType;
  @Output() menuItemClick = new EventEmitter<void>();

  private _showMenu: boolean;

  get desktopView(): boolean {
    return this.viewType === ViewType.desktop;
  }

  get mobileView(): boolean {
    return this.viewType === ViewType.mobile;
  }

  get showMenu(): boolean {
    if (!this.definition || !this.definition.menuDefinition || this.definition.menuDefinition.length === 0) {
      return false;
    }
    return this._showMenu;
  }

  set showMenu(value: boolean) {
    this._showMenu = value;
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (this.definition.menuDefinition && this.desktopView) {
      this.showMenu = true;
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.desktopView) {
      this.showMenu = false;
    }
  }

  ngOnInit() {}

  openMenu() {
    if (this.definition.hasMenu) {
      this.showMenu = !this.showMenu;
    } else {
      this.menuItemClick.emit();
      this._navigation.navigate([this.definition.href]);
    }
  }

  onSubMenuClick() {
    this.menuItemClick.emit();
  }
}
